import { useCallback } from 'react'

const normalizeLabel = (raw = '') =>
  raw
    .replace(/_/g, ' ')
    .toLowerCase()
    .split(' ')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')

export function useAutoSelectCategories(categories = []) {
  const selectCategory = useCallback(
    (valueTypes) => {
      const types = Array.isArray(valueTypes)
        ? valueTypes
        : typeof valueTypes === 'string'
          ? [valueTypes]
          : []

      // try to find any matching category in one line
      const match =
        types
          .map(normalizeLabel)
          .map((label) => categories.find((cat) => cat.label === label))
          .find(Boolean) || categories.find((cat) => cat.label === 'Others')

      return match
    },
    [categories],
  )

  return { selectCategory }
}
